import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import Products from "../Steps/Product"
import Pay from "../Steps/Pay"
import store from "../../veux/store"

// Use the following examples of URL
// Portal=PAY&Entity=292&Type=Organisation
// Portal=PAY&Entity=841&Type=Team
// Entity is the team or Organisations code
// Type can be either Team or Organisation to look up in Products
// TestPay=YES optional parameter for Test Payments

let step1, step2, step3, step5

// Load Models
const LoadModel = async (Passed) => {
    let result = {
        Portal: 'Payment Portal',
        MainColor: "#f5924c",
        TestPay: Passed.TestPay,
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>Payment Portal</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            step3,
            //Step 4
            {
                stepno: 4,
                title: 'Submit',
                valid: true,
                information: `Submitted Contact Information and Product and proceed to Payment.</br>`,
                Model: {},
                Schema: {}
            },
            // Step 5
            step5,
            // // Step 6
            // {
            //     stepno: 6,
            //     title: 'Finalisation',
            //     valid: true,
            //     information: `Thank you for your submitted Payment.</br>`,
            //     Model: {},
            //     Schema: {}
            // }
        ]
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        step3 = await Products.LoadSchema(3, Parameters.Entity, Parameters.Type)
        step5 = await Pay.LoadSchema(5)
        let result = await LoadModel(Parameters)
        return result;
    },
}